import React from "react";

const Badge = ({ txt, style }) => {
  return (
    <span
      className={`bg-yellow-100 text-yellow-800 text-xs rounded-sm font-medium me-2 
  px-3 py-1 w-fit dark:bg-yellow-800/80 dark:text-yellow-100 ${style}`}
    >
      {txt}
    </span>
  );
};

export default Badge;
